import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import {
  TYPE_BAGGAGE,
  TYPE_DRAWER,
  TYPE_TRANSFERS,
  TypeRefundTicketAvia,
  TypeRefundTicketAviaList,
} from 'shared/constants'
import { BlockArrow } from 'shared/ui/block-arrow'
import { BlockSelect, TYPE_RESULT } from 'shared/ui/block-select'
import { ButtonContinue } from 'shared/ui/bottom-continue'
import { HeaderResetButton } from 'shared/ui/header-reset-button'

import { ComfortFilter, PriceFilter } from './components'
import { useFilterState } from './hooks'
import { getListTransfers } from './model'
import styles from './styles.module.scss'

const FilterDrawer = observer(() => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  const {
    state,
    filterDataFromRequest,
    hasActiveFilters,
    hasChanges,
    onChangeBaggage,
    onChangeTransfer,
    onChangePriceFilter,
    onSubmit,
    onReset,
    onChangeComfortFilter,
    isDisabledComfort,
    onChangeTypeRefund,
  } = useFilterState()

  const LIST_BAGGAGE = [
    {
      key: TYPE_BAGGAGE.EMPTY,
      title: t('hasnot_baggage'),
    },
    {
      key: TYPE_BAGGAGE.HAND_BAGGAGE,
      title: t('hand_baggage'),
    },
    {
      key: TYPE_BAGGAGE.SUITCASE,
      title: t('with_suitcase'),
    },
    {
      key: TYPE_BAGGAGE.ALL_OPTIONS,
      title: t('all_options'),
    },
  ]

  const showAirlines = (typeDrawer?: TYPE_DRAWER) => {
    if (typeDrawer === TYPE_DRAWER.AIRLINES) {
      navigate(RoutingPaths.avia.filter.aircompany.path())
    }

    if (typeDrawer === TYPE_DRAWER.AIRPORTS) {
      navigate(RoutingPaths.avia.filter.airport.path())
    }

    if (typeDrawer === TYPE_DRAWER.TIMER) {
      navigate(RoutingPaths.avia.filter.timer.path())
    }
  }

  const onBack = () => {
    navigate(-1)
  }

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <HeaderResetButton
          isCanDisable={hasActiveFilters}
          title={t('filter')}
          onBack={onBack}
          onReset={onReset}
        />
      </div>

      <div className={styles.wrapperFilterItem}>
        <PriceFilter
          currentPrice={state.rangePrice}
          priceRange={filterDataFromRequest?.priceRange}
          onChange={onChangePriceFilter}
        />

        <div className={styles.itemBlock}>
          <BlockSelect
            typeOption={TYPE_RESULT.RADIO}
            title={t('avia_refund_ticket')}
            active={[state?.refundTicket || TypeRefundTicketAvia.All.key]}
            listOption={TypeRefundTicketAviaList?.map((option) => ({
              key: option.key,
              title: t(option.name),
            }))}
            onChange={(value) => onChangeTypeRefund(value as string)}
          />
        </div>

        <div className={styles.itemBlock}>
          <BlockSelect
            active={[state?.baggage || '']}
            title={t('baggage')}
            listOption={LIST_BAGGAGE}
            typeOption={TYPE_RESULT.RADIO}
            onChange={(value) => onChangeBaggage(value as string)}
          />
        </div>

        <div className={styles.itemBlock}>
          <BlockSelect
            active={[state?.transfers || '']}
            title={t('transfers')}
            listOption={getListTransfers(t)}
            typeOption={TYPE_RESULT.RADIO}
            onChange={(value) => onChangeTransfer(value as TYPE_TRANSFERS)}
          />
        </div>

        {/* <div className={clsx(styles.charter, styles.itemBlock)}>
          <span
            className={styles.text}
            onClick={() => onChangeCharter(!state.isOffCharter)}
          >
            {t('charter')}
          </span>

          <Switch
            isChecked={!state.isOffCharter}
            onChange={value => onChangeCharter(!value)}
          />
        </div> */}

        <ComfortFilter
          isDisabled={isDisabledComfort}
          filter={state}
          maxValue={{
            min: filterDataFromRequest?.transferTimer?.min_duration,
            max: filterDataFromRequest?.transferTimer?.max_duration,
          }}
          onChangeComfortFilter={onChangeComfortFilter}
        />

        <BlockArrow
          text={t('time')}
          onClick={() => showAirlines(TYPE_DRAWER.TIMER)}
        />

        <BlockArrow
          text={t('airports')}
          onClick={() => showAirlines(TYPE_DRAWER.AIRPORTS)}
        />

        <BlockArrow
          text={t('airlines')}
          onClick={() => showAirlines(TYPE_DRAWER.AIRLINES)}
        />

        <ButtonContinue
          onClick={onSubmit}
          disabled={!hasChanges}
        >
          <span className={styles.text}>{t('apply')}</span>
        </ButtonContinue>
      </div>
    </div>
  )
})

export default FilterDrawer
